import { HttpParams } from "@angular/common/http";

export class Paginacao<T> {
  private ordenacaoDefaut: string;
  private ordenacaoAscDefault: boolean;

  ordenaPor: string;
  numeroPagina: number;
  tamanho: number;
  totalPaginas: number;
  pageIndex: number;
  pageSize: number;
  totalPages: number;
  totalItemCount: number;
  listaItens: T[];
  totalItens: number;
  listaTodos: boolean;
  ordenacaoAsc: boolean;
  itens: T[];
  pageNumber: number;

  constructor(
    ordenaPor: string,
    PageIndex: number,
    tamanho: number,
    listaTodos: boolean,
    ordenacaoAsc = true
  ) {
    this.ordenaPor = ordenaPor;
    this.ordenacaoDefaut = ordenaPor;
    this.numeroPagina = PageIndex;
    this.tamanho = tamanho;
    this.listaTodos = listaTodos;
    this.ordenacaoAsc = ordenacaoAsc;
    this.ordenacaoAscDefault = ordenacaoAsc;
  }

  public alterarOrdenacao(orderBy: string) {
    if (this.ordenaPor === orderBy && !this.ordenacaoAsc) {
      this.ordenaPor = this.ordenacaoDefaut;
      this.ordenacaoAsc = this.ordenacaoAscDefault;
    } else if (this.ordenaPor === orderBy) {
      this.ordenacaoAsc = false;
    } else {
      this.ordenaPor = orderBy;
      this.ordenacaoAsc = true;
    }
  }

  public setData(
    data: Paginacao<T> & { tamanhoPagina?: number },
    argType: { new(item?): T }
  ) {
    if (!data) {
      this.listaItens = [];
      return;
    }

    this.numeroPagina = data.numeroPagina;
    this.tamanho = data.tamanhoPagina;
    this.totalPaginas = data.totalPaginas;
    this.totalItens = data.totalItens;
    this.listaItens = data.listaItens.map((e) => new argType(e));
  }

  public retornaParametros(): HttpParams {
    return new HttpParams()
      .set("PageSize", this.tamanho.toString())
      .set("PageIndex", this.numeroPagina.toString())
      .set("OrderByProperty", this.ordenaPor)
      .set("listAll", this.listaTodos ? "true" : "false")
      .set("OrderByDesc", this.ordenacaoAsc ? "true" : "false")
      .set("PageNumber", this.numeroPagina.toString());
  }

  public retornaParametrosOld(): HttpParams {
    return new HttpParams()
      .set("Tamanho", this.tamanho.toString())
      .set("Pagina", this.numeroPagina.toString())
      .set("ordenaPor", this.ordenaPor)
      .set("listaTodos", this.listaTodos ? "true" : "false")
      .set("ordenacaoAsc", this.ordenacaoAsc ? "true" : "false");
  }
}
